import React from 'react';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mockData';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleWhatsApp = () => {
    const message = encodeURIComponent("Hola GONSO, quisiera cotizar productos/hortalizas para mi negocio");
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${message}`, '_blank');
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/058gyoft_WhatsApp%20Image%202026-02-20%20at%207.23.33%20PM.jpeg"
              alt="GONSO"
              className="h-20 w-auto mb-4 brightness-110"
            />
            <p className="text-gray-400 leading-relaxed">
              Producción y comercialización de hortalizas frescas al por mayor en Honduras.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#019645]">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('nosotros')}
                  className="text-gray-400 hover:text-[#019645] transition-colors"
                >
                  Quiénes Somos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('productos')}
                  className="text-gray-400 hover:text-[#019645] transition-colors"
                >
                  Productos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('capacidad')}
                  className="text-gray-400 hover:text-[#019645] transition-colors"
                >
                  Capacidad y Logística
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('calidad')}
                  className="text-gray-400 hover:text-[#019645] transition-colors"
                >
                  Calidad e Inocuidad
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#019645]">Nuestros Productos</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Tomate Variedad Pony</li>
              <li>Chile Nataly e Iguazú</li>
              <li>Cebolla (varias variedades)</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#019645]">Contacto</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center text-gray-400 hover:text-[#019645] transition-colors"
                >
                  <Phone size={18} className="mr-2 flex-shrink-0" />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center text-gray-400 hover:text-[#019645] transition-colors break-all"
                >
                  <Mail size={18} className="mr-2 flex-shrink-0" />
                  {companyInfo.email}
                </a>
              </li>
              <li>
                <button
                  onClick={handleWhatsApp}
                  className="flex items-center text-gray-400 hover:text-[#019645] transition-colors"
                >
                  <MessageCircle size={18} className="mr-2 flex-shrink-0" />
                  WhatsApp
                </button>
              </li>
              <li className="flex items-start text-gray-400">
                <MapPin size={18} className="mr-2 flex-shrink-0 mt-1" />
                <span className="text-sm">{companyInfo.location}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-gray-400 text-sm">
            <p>© {currentYear} GONSO - Produciendo para Honduras. Todos los derechos reservados.</p>
            <p className="mt-2 md:mt-0">Entregas a nivel nacional</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
